import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useParams } from "react-router-dom";
import roomsArray from "../../roomData.js";

const RmDetailsHeroArea = () => {
  const [rooms, setRooms] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    setRooms(roomsArray);
  }, []);

  const findRoom = rooms && rooms.find((room) => room.id === parseInt(id));

  return (
    <Wrapper>
      <div className="breadcumb-area d-flex align-items-center">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="breacumb-content">
                <div className="breadcum-title">
                  <h4 className="mt-0">{findRoom && findRoom.subtitle}</h4>
                </div>
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>&nbsp;/&nbsp;</li>
                  <li>Accommodation Details</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .breadcumb-area {
    padding: 170px 0 120px;
  }
`;

export default RmDetailsHeroArea;
